import { RapidStateCreator } from "../types";

export enum WaitlistFeature {
    ContinuousImprovement = "continuous-improvement"
}

export interface WaitlistSliceState {
    // State: { [userId]: { [feature]: boolean } }
    joinedWaitlists: Record<string, Record<WaitlistFeature, boolean>>;

    // Getters
    hasJoinedWaitlist: (userId: string | null, feature: WaitlistFeature | null) => boolean;

    // Actions
    joinWaitlist: (userId: string, feature: WaitlistFeature) => void;
    leaveWaitlist: (userId: string, feature: WaitlistFeature) => void;
}

export const createWaitlistSlice: RapidStateCreator<WaitlistSliceState> = (set, get) => ({
    // Initial state
    joinedWaitlists: {},

    // Getters
    hasJoinedWaitlist: (userId: string | null, feature: WaitlistFeature | null) => {
        if (!userId || !feature) return false;
        return get().joinedWaitlists[userId]?.[feature] === true;
    },

    // Actions
    joinWaitlist: (userId: string, feature: WaitlistFeature) => {
        const currentWaitlists = get().joinedWaitlists;
        const updatedWaitlists = {
            ...currentWaitlists,
            [userId]: { ...currentWaitlists[userId], [feature]: true }
        };
        set({ joinedWaitlists: updatedWaitlists }, false, "joinWaitlist");
    },

    leaveWaitlist: (userId: string, feature: WaitlistFeature) => {
        const currentWaitlists = get().joinedWaitlists;
        const userWaitlists = { ...currentWaitlists[userId] };

        // Remove the feature
        delete userWaitlists[feature];

        // Clean up empty user objects
        const updatedWaitlists = { ...currentWaitlists };
        if (Object.keys(userWaitlists).length === 0) {
            delete updatedWaitlists[userId];
        } else {
            updatedWaitlists[userId] = userWaitlists;
        }

        set({ joinedWaitlists: updatedWaitlists }, false, "leaveWaitlist");
    }
});
